export enum Sorting {
	BestFlight,
	Departure,
	Optimal,
	Price,
	FlightTime,
	Arrival,
	Nonstop,
	BusinessClass
}
